import { Route, Routes } from 'react-router-dom';
import { APP_BASE_PATH } from '../consts/route-consts';
import { useAppInfo } from "../helpers/hooks/common-hook";

import Page from "../components/page/page";
import AppListPage from "./agent-manage/agent-list";
import SchedulerListPage from "./schedulers";
import TracePage from "./traces";

import CodehooksListPage from "./codehook/codehook-list";
import CodehookSavePage from "./codehook/codehook-save/codehook-save-page";

import Subscription from "./subscription";

import NotificationList from "./notification/list";

import AppAccessKeyListPage from "./agent-manage/access-key/app-access-key-list/app-access-key-page";
import Index from "./agent-manage/agent-general-settings";
import AppLiveAgentPage from "./agent-manage/live-agent-settings";
import AppLLMSettingsPage from "./agent-manage/llm-settings";
import VersionListPage from "./agent-manage/version/version-list";
import { ApplicationsList } from "./agent-manage/agent-list";

import UsersListPage from "./account/users/users-list";

import ActionJourneyStudioPage from "./action-journey-studio";
import PlaybookListPage from "./playbooks";
import PlaybookEditorPage from "./playbooks/playbook-editor";
import AgentSettingsPage from "./agent-manage/agent-instruction";
import AgentActionsListPage from "./agent/agent-actions/action-list";
import AgentActionsSettingsPage from "./agent/agent-actions/action-settings";

// import IntegrationCustomize from "./channels/integration-customize/integration-web-page";
// import IntegrationWebPage from "./channels/integration-web/integration-web-page";
import IntegrationChannelPage from "./channels/integration-channel/integration-channel-page";
import IntegrationVoicePage from "./channels/integration-voice/integration-voice-page";
import IntegrationWebchatPage, { WebChannelRedirect } from "./channels/integration-webchat/integration-webchat-page";
import TwilioWebPage from "./channels/twilio-channel";

import WorkflowIntegrationList from "./integrations/workflow/workflow-list";

import AuthConnectorSave from "./integrations/auth-connectors/auth-connector-save";
import AuthConnectorsList from "./integrations/auth-connectors/auth-connectors-list";

import ContactUsPage from "./contact-us/contact-us-page";

import FileDSConnector from "./static-knowledge/data-source-connectors/file";
import TextDSConnector from "./static-knowledge/data-source-connectors/text";
import DataSourceManage from "./static-knowledge/data-source-manage";

import ShopifyConnectorsSave from "./integrations/shopify-connectors/shopify-connector-save";
import ShopifyConnectorsList from "./integrations/shopify-connectors/shopify-connectors-list";

import UserProfile from "./user-settings/user-profile";

import LiveChatDashboard from "./live-chat/live-chat-dashboard";
import FineTuneConfig from "./static-knowledge/fine-tune-config";

import AgentPreview from "./agent-preview";

import Analytics from "./analytics";
import ForgotPasswordPage from "./auth/internal-forgot-password";

import AccAccessKeyListPage from "./account/access-key/acc-access-key-list/app-access-key-page";
import LLMSettings from './agent-manage/llm-settings';
import VoiceAISettings from './agent-manage/voice-ai-settings';
import AgentPromptBased from './agent/agent-prompt-based';
import AgentTools from './agent/agent-tools';
import AgentSkills from './agent/agent-skills';
import AgentMcpServers from './agent/agent-mcp-servers';
import AgentSubAgents from './agent/agent-sub-agents';
import WorkflowListPage from './workflows';
import AgentMemory from './agent/agent-memory';
import AgentLlm from './agent/agent-llm';
import AgentEval from './agent/agent-eval';
import CopilotPage from './copilot_native/copilot-page';
import SupportPage from './support';
import SubscriptionUpdatePage from './support/subscription-update';


const DashboardRouter = () => {
  const appInfo = useAppInfo();
  const intentLess = appInfo && appInfo.intentLess;
  return (
    <Routes>
      <Route
        path="/*"
        element={<Page title="Apps" content={<AppListPage />} />}
      />
      <Route
        path="/"
        element={<Page title="Apps" content={<AppListPage />} />}
      />

      {/* Agent Builder Copilot as a page: account scope at /console, app scope at /app/:appId/console. */}
      <Route
        path="/console"
        element={<Page title="Copilot" content={<CopilotPage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/console`}
        element={<Page title="Copilot" content={<CopilotPage />} />}
      />

      <Route
        path="/apps-manage"
        element={
          <Page title="Agent Settings" content={<ApplicationsList />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/agent/settings`}
        element={
          <Page title="Agent Settings" content={<AgentSettingsPage />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/memory`}
        element={<Page title="Agent Memory" content={<AgentMemory />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/agent`}
        element={<Page title="Agent Prompt Based" content={<AgentPromptBased />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/tools`}
        element={<Page title="Agent Tools" content={<AgentTools />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/skills`}
        element={<Page title="Agent Skills" content={<AgentSkills />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/mcp-servers`}
        element={<Page title="Agent MCP Servers" content={<AgentMcpServers />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/sub-agents`}
        element={<Page title="Sub-Agents" content={<AgentSubAgents />} />}
      />

      {/* Per sub-agent config surface — same tabs as the top-level agent,
          scoped to one sub-agent via :subAgentId. */}
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId`}
        element={
          <Page
            title="Sub-Agent Instructions"
            content={<AgentPromptBased />}
          />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId/tools`}
        element={
          <Page
            title="Sub-Agent Tools"
            content={<AgentTools />}
          />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId/skills`}
        element={<Page title="Sub-Agent Skills" content={<AgentSkills />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId/mcp-servers`}
        element={<Page title="Sub-Agent MCP" content={<AgentMcpServers />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId/memory`}
        element={<Page title="Sub-Agent Memory" content={<AgentMemory />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/sub-agents/:subAgentId/llm`}
        element={<Page title="Sub-Agent LLM" content={<AgentLlm />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/agent/actions`}
        element={
          <Page title="Agent Actions List" content={<AgentActionsListPage />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/agent/actions/settings`}
        element={
          <Page
            title="Agent Actions Settings"
            content={<AgentActionsSettingsPage />}
          />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/agent/actions/settings/:actionId/*`}
        element={
          <Page
            title="Agent Actions Settings Update"
            content={<AgentActionsSettingsPage />}
          />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/journey`}
        element={
          <Page title="Workflows" content={<WorkflowListPage />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/journey/:journeyId`}
        element={
          <Page title="Agent Workflow" content={<ActionJourneyStudioPage />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/playbooks`}
        element={<Page title="Playbooks" content={<PlaybookListPage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/playbooks/:playbookId`}
        element={<Page title="Playbooks" content={<PlaybookEditorPage />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/settings`}
        element={<Page title="App Settings" content={<Index />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/access-keys`}
        element={
          <Page title="App AccessKey" content={<AppAccessKeyListPage />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/live-agent`}
        element={<Page title="Live Chat" content={<AppLiveAgentPage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/llm`}
        element={<Page title="LLM Settings" content={<AppLLMSettingsPage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/versions`}
        element={
          <Page title="Versions" content={<VersionListPage />} />
        }
      />
      {/* <Route path={`${APP_BASE_PATH}/channels`}
                   element={<Page title="Integration Web" content={<IntegrationCustomize/>}/>}/> */}
      {/* <Route path={`${APP_BASE_PATH}/channels/customize`}
                   element={<Page title="Integration Web" content={<IntegrationCustomize/>}/>}/> */}
      {/* Channels live under the left rail's Channels group; the Web Chat
          channel has Settings and Install tabs. */}
      <Route path={`${APP_BASE_PATH}/channels`} element={<WebChannelRedirect />} />
      <Route path={`${APP_BASE_PATH}/channels/web`} element={<WebChannelRedirect />} />
      <Route
        path={`${APP_BASE_PATH}/channels/web/settings`}
        element={
          <Page title="Integration Web" content={<IntegrationWebchatPage section="settings" />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/channels/web/install`}
        element={
          <Page title="Integration Web" content={<IntegrationWebchatPage section="install" />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/channels/voice`}
        element={
          <Page title="Integration Web" content={<IntegrationVoicePage />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/channels/fb`}
        element={
          <Page
            title="Integration Web"
            content={
              <IntegrationChannelPage
                channel="facebook"
                titlePrefix="Facebook"
                subTitle="Messenger integration"
                callbackUrlLabel="Callback URL"
                accessKeyLabel="Access token"
                verifyTokenEnable={true}
                verifyTokenLabel="Verify token"
              />
            }
          />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/channels/twilio`}
        element={<Page title="Twilio Web" content={<TwilioWebPage />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/channels/whatsapp`}
        element={
          <Page
            title="Integration Whatsapp"
            content={
              <IntegrationChannelPage
                channel="whatsapp"
                titlePrefix="Whatsapp"
                subTitle="Whatsapp integration"
                callbackUrlLabel="Callback URL"
                accessKeyLabel="Access token"
                verifyTokenEnable={true}
                verifyTokenLabel="Verify token"
              />
            }
          />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/channels/slack`}
        element={
          <Page
            title="Integration Slack"
            content={
              <IntegrationChannelPage
                channel="slack"
                titlePrefix="Slack"
                subTitle="Slack bot integration"
                callbackUrlLabel="Events Callback Url"
                accessKeyLabel="Bot User OAuth Token"
                verifyTokenEnable={false}
              />
            }
          />
        }
      />

      {/*<Route path={`${APP_BASE_PATH}/codehook/*`} element={<Page title="CodeHook" content={<CodehooksManagePage />} />} />*/}
      <Route
        path={`${APP_BASE_PATH}/contents`}
        element={<Page title="DataSource" content={<DataSourceManage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/functions/*`}
        element={<Page title="CodeHook" content={<CodehooksListPage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/functions/create`}
        element={
          <Page title="CodeHook Create" content={<CodehookSavePage />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/functions/save/:codehookId`}
        element={<Page title="CodeHook Save" content={<CodehookSavePage />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/knowledge-base/docs/data-sources`}
        element={<Page title="Knowledge" content={<DataSourceManage />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/knowledge-base/docs/data-sources/connectors/file`}
        element={<Page title="File" content={<FileDSConnector />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/knowledge-base/docs/data-sources/connectors/text`}
        element={<Page title="Text" content={<TextDSConnector />} />}
      />
      <Route
        path={`${APP_BASE_PATH}/knowledge-base/fine-tune`}
        element={<Page title="Knowledge" content={<FineTuneConfig />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/integrations/workflow`}
        element={
          <Page title="Workflow" content={<WorkflowIntegrationList />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/integrations/auth-connectors`}
        element={
          <Page title="AuthConnectors" content={<AuthConnectorsList />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/integrations/auth-connectors/save`}
        element={
          <Page title="AuthConnectors" content={<AuthConnectorSave />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/integrations/auth-connectors/save/:authConnId`}
        element={
          <Page title="AuthConnectors" content={<AuthConnectorSave />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/integrations/shopify`}
        element={
          <Page title="AuthConnectors" content={<ShopifyConnectorsList />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/integrations/shopify/save`}
        element={
          <Page title="AuthConnectors" content={<ShopifyConnectorsSave />} />
        }
      />
      <Route
        path={`${APP_BASE_PATH}/integrations/shopify/save/:id`}
        element={
          <Page title="AuthConnectors" content={<ShopifyConnectorsSave />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/hitl`}
        element={
          <Page title="LiveChatDashboard" content={<LiveChatDashboard />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/agent-preview`}
        element={
          <Page title="agent-preview" content={<AgentPreview />} />
        }
      />

      <Route
        path={`/notifications`}
        element={<Page title="Notifications" content={<NotificationList />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/analytics`}
        element={<Page title="Analytics" content={<Analytics />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/schedulers`}
        element={<Page title="Schedulers" content={<SchedulerListPage />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/traces`}
        element={<Page title="Trace" content={<TracePage />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/evaluation`}
        element={<Page title="Agent Tests" content={<AgentEval />} />}
      />

      <Route
        path="/support"
        element={<Page title="Support" content={<SupportPage />} />}
      />

      <Route
        path="/support/subscription-update"
        element={<Page title="Subscription Update" content={<SubscriptionUpdatePage />} />}
      />

      <Route
        path={`/user-settings/profile`}
        element={<Page title="UserProfile" content={<UserProfile />} />}
      />
      <Route
        path={`/user-settings/subscription/*`}
        element={<Page title="Subscription" content={<Subscription />} />}
      />

      <Route
        path={`${APP_BASE_PATH}/llm-settings`}
        element={
          <Page title="LLMSettings" content={<LLMSettings />} />
        }
      />

      <Route
        path={`${APP_BASE_PATH}/voice`}
        element={
          <Page title="Voice AI Settings" content={<VoiceAISettings />} />
        }
      />

      <Route
        path={`/account/access-keys`}
        element={<Page title="Account Access Key" content={<AccAccessKeyListPage />} />}
      />

      <Route
        path={`/account/users`}
        element={<Page title="Users" content={<UsersListPage />} />}
      />

      <Route path="/contact-us" element={<ContactUsPage />} />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    </Routes>
  );
};

export default DashboardRouter;
